/* Flore "How can I help you?" v3 (Craig 2026-10-08: re-vamp "Start the Intake" to "How can I help you",
 * help-first menu). v2 (2026-10-02) was a popout with five tap questions. The launcher opens Craig's welcome
 * video and one question, "How can I help you?":
 *   gut symptoms      \u2192 the five tap questions (unchanged), then contact + consent \u2192 Send
 *   which test/program \u2192 hands off to the program finder (host option `finder`, else the page's .js-quiz,
 *                        else flore.com); nothing is sent
 *   my order / something else \u2192 a short note, then contact + consent \u2192 Send
 *   talk to a specialist \u2192 how to reach you, then contact + consent \u2192 Send
 * Scripted (no AI). Nothing leaves the browser until Send; then one POST to
 * flore-concierge /intake \u2192 one support@flore.com ticket (answers.need names the path).
 * Mount: FloreIntaker.mount(el, {video, poster, name, email, source})
 *    or: <div data-flore-intaker data-video=".." data-poster=".."></div> */
(function () {
  if (window.FloreIntaker) return;
  var API = 'https://portal.flore.com/api/concierge/intake';
  var CONTACT_V = 'intake-contact-v3-2026-10-08';
  var CONTACT_T = "Flore may use my answers and contact details so Flore's team can contact me about this request. This is not medical advice.";
  var MKT_V = 'intake-email-v1-2026-10-02';
  var MKT_T = 'Also email me Flore gut-health tips and offers. Unsubscribe anytime.';
  var STORE = 'flore_intaker_v3';
  var RED_FLAG = 'Blood in stool or unexplained weight loss';
  var RED_FLAG_RE = /blood in (my |the )?stool|bloody stool|unexplained weight loss/i;
  var FINDER_URL = 'https://flore.com/';
  // "How can I help you?" \u2014 the first and only top-level question.
  var NEEDS = [
    { k: 'finder', label: 'Find your program', cta: true }, // the main CTA, first and filled (Craig 2026-10-08)
    { k: 'symptoms', label: "My gut symptoms (or my child's)" },
    { k: 'order', label: 'A question about my order' },
    { k: 'specialist', label: 'Talk to a gut health specialist' },
    { k: 'other', label: 'Something else' }
  ];
  var NOTE_Q = { order: "What's your question? Add your order number if you have it.", other: 'Tell us what you need.' };
  var Q = [
    { k: 'forWhom', q: 'Who is this for?', opts: ['Me', 'My child', 'Another family member', 'A study participant'] },
    { k: 'age', q: function (a) { return a.forWhom === 'Me' ? 'How old are you?' : 'How old are they?'; },
      opts: ['Under 3', '3 to 12', '13 to 17', '18 to 39', '40 to 64', '65 or older'] },
    { k: 'concerns', q: "What's going on? Pick any that fit.", multi: true, other: true,
      opts: ['Bloating or gas', 'Constipation', 'Diarrhea or loose stools', 'Reflux or heartburn', 'Mood or anxiety',
        'Sleep', 'Focus or brain fog', 'Skin', RED_FLAG] },
    { k: 'duration', q: 'How long has this been going on?', opts: ['Less than 3 months', '3 to 12 months', '1 to 3 years', 'More than 3 years'] },
    { k: 'contact', q: 'How should our gut health specialist reach you?', opts: ['Email', 'Phone call', 'Text message'] }
  ];
  var VTT = 'WEBVTT\n\n' + [
    ['00:00.000', '00:01.760', 'And welcome into Flore.'],
    ['00:01.760', '00:02.960', 'My name is Craig Rouskey.'],
    ['00:02.960', '00:05.080', "I'm the CEO and co-founder"],
    ['00:05.080', '00:07.660', 'and part-time chief scientific officer'],
    ['00:07.660', '00:09.400', 'of this organization.'],
    ['00:09.400', '00:11.760', "It's great to see you here."],
    ['00:11.760', '00:13.600', 'You know, we acknowledge that everyone'],
    ['00:13.600', '00:16.120', 'has gut health issues from time to time,'],
    ['00:16.120', '00:19.800', 'and we are more than excited to help you on your journey.'],
    ['00:19.800', '00:21.620', 'If you need anything from us,'],
    ['00:21.620', '00:25.460', 'please reach out at support@flore.com,'],
    ['00:25.460', '00:27.240', 'answer the questions below,'],
    ['00:27.240', '00:29.560', 'and a gut health specialist will contact you'],
    ['00:29.560', '00:31.400', 'as soon as possible.'],
    ['00:31.400', '00:33.040', 'Thank you for stopping in,'],
    ['00:33.040', '00:34.840', 'and we look forward to serving you.']
  ].map(function (c) { return c[0] + ' --> ' + c[1] + '\n' + c[2]; }).join('\n\n') + '\n';

  // Flore plum palette; picks up the host page's own tokens where they exist.
  var CSS = '' +
    '.fi-card,.fi-dlg{--fi-ink:var(--text-dark,#2C2428);--fi-mute:var(--text-muted,#6B6669);--fi-brand:var(--plum,#5C3D5E);--fi-head:var(--plum-deep,#3D2840);' +
    '--fi-bg:var(--warm-white,#FFFDFB);--fi-soft:var(--card-tint,#F6EEF2);--fi-line:var(--border,#E7DED6);color:var(--fi-ink);line-height:1.45;text-align:left;' +
    'font-family:var(--sans,var(--font-body,"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif))}' +
    '.fi-fl{font-family:var(--sans,var(--font-body,"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif))!important}' +
    '.fi-card *,.fi-dlg *{box-sizing:border-box}' +
    '.fi-card{display:flex;gap:14px;align-items:center;width:100%;padding:12px;margin:0 0 18px;background:var(--fi-bg);border:1px solid var(--fi-line);border-radius:14px;cursor:pointer;font:inherit;text-align:left}' +
    '.fi-card:hover{border-color:var(--fi-brand)}.fi-card:focus-visible{outline:2px solid var(--fi-brand);outline-offset:2px}' +
    '.fi-th{position:relative;flex:none;width:64px;height:84px;border-radius:10px;background:#c9c9cb center/cover no-repeat}' +
    '.fi-th:after{content:"";position:absolute;left:50%;top:50%;width:28px;height:28px;margin:-14px 0 0 -14px;border-radius:50%;background:rgba(255,255,255,.92) url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M9 7l8 5-8 5z%27 fill=%27%235C3D5E%27/%3E%3C/svg%3E") center/18px no-repeat}' +
    '.fi-ct{flex:1;min-width:0}.fi-ct b{display:block;color:var(--fi-head);font-size:1.02em}.fi-ct span{display:block;color:var(--fi-mute);font-size:.88em;margin-top:2px}' +
    '.fi-go{flex:none;border-radius:999px;background:var(--fi-brand);color:#fff;font-weight:600;padding:9px 16px;font-size:.92em}' +
    // Floating launcher: a small square fixed lower-left (Craig 2026-10-02).
    '.fi-fl{position:fixed;left:16px;bottom:16px;z-index:2147482000;width:92px;height:112px;padding:0;border:0;border-radius:14px;overflow:hidden;cursor:pointer;' +
    'background:#c9c9cb center 20%/cover no-repeat;box-shadow:0 8px 24px rgba(30,20,32,.35);font:inherit;transition:transform .15s}' +
    '.fi-fl:hover{transform:translateY(-2px)}.fi-fl:focus-visible{outline:3px solid #fff;box-shadow:0 0 0 6px var(--plum,#5C3D5E)}' +
    '.fi-fl .fi-pl{position:absolute;left:50%;top:38%;width:30px;height:30px;margin:-15px 0 0 -15px;border-radius:50%;background:rgba(255,255,255,.92) url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M9 7l8 5-8 5z%27 fill=%27%235C3D5E%27/%3E%3C/svg%3E") center/18px no-repeat}' +
    '.fi-fl .fi-lb{position:absolute;left:0;right:0;bottom:0;padding:6px 4px 7px;background:var(--plum,#5C3D5E);color:#fff;font-size:11.5px;line-height:1.15;font-weight:700;text-align:center}' +
    '.fi-right .fi-fl{left:auto;right:16px}' +
    '@media (max-width:700px){.fi-right .fi-fl{left:auto;right:10px}}' +
    '@media (max-width:700px){.fi-fl{left:10px;bottom:10px;width:64px;height:80px;border-radius:12px}.fi-fl .fi-pl{width:24px;height:24px;margin:-12px 0 0 -12px;background-size:15px}.fi-fl .fi-lb{font-size:9.5px;padding:4px 2px 5px}}' +
    '.fi-ov{position:fixed;inset:0;z-index:2147483000;background:rgba(30,20,32,.55);display:flex;align-items:center;justify-content:center;padding:16px}' +
    '.fi-ov.fi-ov-l{align-items:flex-end;justify-content:flex-start}.fi-ov.fi-ov-l.fi-ov-r{justify-content:flex-end}' +
    '.fi-ov-l .fi-dlg{max-width:760px;height:min(560px,calc(100vh - 32px))}' +
    '.fi-dlg{position:relative;background:var(--fi-bg);border-radius:18px;width:100%;max-width:860px;max-height:calc(100vh - 32px);overflow:hidden;display:grid;grid-template-columns:280px minmax(0,1fr);box-shadow:0 24px 70px rgba(0,0,0,.3);font-size:16px}' +
    '.fi-vw{background:#1b1416;display:flex;align-items:center}' +
    '.fi-vid{width:100%;height:100%;max-height:calc(100vh - 32px);object-fit:cover;display:block;background:#1b1416}' +
    '.fi-pn{display:flex;flex-direction:column;min-height:0;max-height:calc(100vh - 32px);padding:22px 22px 16px}' +
    '.fi-x{position:absolute;top:10px;right:10px;z-index:2;width:36px;height:36px;border-radius:50%;border:0;background:rgba(255,255,255,.92);color:#2C2428;font-size:22px;line-height:36px;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.2)}' +
    '.fi-h{margin:0 40px 2px 0;font-size:1.35rem;line-height:1.2;color:var(--fi-head);font-weight:700}' +
    '.fi-pg{margin:0 0 10px;color:var(--fi-mute);font-size:.85em}' +
    '.fi-bar{height:4px;background:var(--fi-line);border-radius:4px;margin:0 0 14px;overflow:hidden}.fi-bar i{display:block;height:100%;background:var(--fi-brand);transition:width .25s}' +
    '.fi-log{flex:1;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:9px;padding:2px}' +
    '.fi-m{max-width:90%;padding:9px 13px;border-radius:14px;font-size:.95em;white-space:pre-wrap}' +
    '.fi-a{background:var(--fi-soft);align-self:flex-start;border-bottom-left-radius:4px}' +
    '.fi-u{background:var(--fi-brand);color:#fff;align-self:flex-end;border-bottom-right-radius:4px}' +
    '.fi-warn{background:#FFF1E6;color:#7A3B12;align-self:stretch;border-radius:10px}' +
    '.fi-ops{display:flex;flex-wrap:wrap;gap:8px;margin:4px 0 2px}' +
    '.fi-op{appearance:none;border:1.5px solid var(--fi-brand);background:#fff;color:var(--fi-brand);border-radius:999px;padding:8px 14px;font:inherit;font-size:.92em;cursor:pointer;min-height:40px}' +
    '.fi-op[aria-pressed=true]{background:var(--fi-brand);color:#fff}' +
    '.fi-need{flex-direction:column;align-items:stretch}.fi-need .fi-op{text-align:left;border-radius:12px;padding:10px 14px}' +
    '.fi-need .fi-op.fi-cta{background:var(--fi-brand);color:#fff;font-weight:700}' +
    '.fi-ta{min-height:96px;resize:vertical;line-height:1.4}' +
    '.fi-op:focus-visible,.fi-btn:focus-visible{outline:2px solid var(--fi-brand);outline-offset:2px}' +
    '.fi-btn{appearance:none;border:0;border-radius:999px;background:var(--fi-brand);color:#fff;font:inherit;font-weight:600;padding:10px 20px;cursor:pointer;min-height:42px}' +
    '.fi-btn[disabled]{opacity:.45;cursor:not-allowed}' +
    '.fi-in{width:100%;padding:10px 12px;border:1px solid #D8CCC1;border-radius:10px;font:inherit;color:var(--fi-ink);background:#fff}' +
    '.fi-f{display:grid;gap:9px;margin-top:4px}' +
    '.fi-ck{display:flex;gap:9px;align-items:flex-start;font-size:.84em}.fi-ck input{margin-top:3px;flex:none;width:17px;height:17px;accent-color:var(--fi-brand)}' +
    '.fi-note{font-size:.78em;color:var(--fi-mute);margin:6px 0 0}.fi-note a,.fi-ck a{color:var(--fi-brand)}' +
    '.fi-err{color:#a12d2d;font-size:.85em;margin:0;min-height:1em}' +
    '.fi-lnk{background:none;border:0;padding:0;color:var(--fi-brand);text-decoration:underline;font:inherit;font-size:.85em;cursor:pointer}' +
    '@media (max-width:700px){.fi-ov,.fi-ov.fi-ov-l{padding:0;align-items:stretch}.fi-dlg,.fi-ov-l .fi-dlg{border-radius:0;max-width:none;max-height:100vh;height:100%;grid-template-columns:1fr;grid-template-rows:auto minmax(0,1fr)}' +
    '.fi-vw{justify-content:center}.fi-vid{height:32vh;max-height:32vh;width:auto;max-width:100%;object-fit:contain}.fi-pn{max-height:none;padding:16px 16px 12px}}';

  function css() {
    if (document.getElementById('fi-css')) return;
    var s = document.createElement('style'); s.id = 'fi-css'; s.textContent = CSS; document.head.appendChild(s);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function load() { try { return JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch (e) { return null; } }
  function save(st) { try { sessionStorage.setItem(STORE, JSON.stringify(st)); } catch (e) {} }
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function fresh(o) { return { need: '', step: 0, a: {}, msg: '', name: o.name || '', email: o.email || '', done: false }; }

  // Floating mode: FloreIntaker.float({video, poster, prefill: () => ({name, email})})
  function float(o) {
    if (document.getElementById('fi-float')) return;
    var host = document.createElement('div'); host.id = 'fi-float'; document.body.appendChild(host);
    if (o && o.side === 'right') host.className = 'fi-right'; // lower right (Craig 2026-10-08), default lower left
    o = o || {}; o.float = true; mount(host, o);
  }

  function mount(el, o) {
    if (!el) return; o = o || {}; css();
    var d = el.dataset || {};
    var video = o.video || d.video || '', poster = o.poster || d.poster || '';
    var source = o.source || location.href.split('#')[0].slice(0, 300);
    var st = load() || fresh(o);
    if (!st.done) { if (o.name && !st.name) st.name = o.name; if (o.email && !st.email) st.email = o.email; }

    function card() {
      el.innerHTML = '';
      if (o.float) {
        var f = document.createElement('button'); f.type = 'button'; f.className = 'fi-fl';
        f.setAttribute('aria-haspopup', 'dialog');
        f.setAttribute('aria-label', st.done ? 'Message sent. Rewatch the welcome video' : 'Start your journey. A welcome from Craig and a few quick taps');
        if (poster) f.style.backgroundImage = "url('" + poster.replace(/'/g, '%27') + "')";
        f.innerHTML = '<span class="fi-pl"></span><span class="fi-lb">' + (st.done ? 'Message sent' : (st.need ? 'Continue' : 'Start your journey')) + '</span>';
        f.addEventListener('click', function () { open(f); });
        el.appendChild(f);
        return;
      }
      var b = document.createElement('button'); b.type = 'button'; b.className = 'fi-card';
      b.setAttribute('aria-haspopup', 'dialog');
      b.innerHTML = '<span class="fi-th"' + (poster ? ' style="background-image:url(\'' + esc(poster) + '\')"' : '') + '></span>' +
        '<span class="fi-ct"><b>' + (st.done ? 'Thanks, your message is in' : 'Start your journey') + '</b>' +
        '<span>' + (st.done ? "Flore's team will contact you as soon as possible." : 'A quick welcome from Craig, our CEO, then tell us what you need.') + '</span></span>' +
        '<span class="fi-go">' + (st.done ? 'Watch' : (st.need ? 'Continue' : 'Start')) + '</span>';
      b.addEventListener('click', function () { open(b); });
      el.appendChild(b);
    }

    function open(opener) {
      // Prefill from the host page at open time (e.g. the quiz's name/email gate).
      if (!st.done && typeof o.prefill === 'function') {
        try { var pf = o.prefill() || {}; if (pf.name && !st.name) st.name = pf.name; if (pf.email && !st.email) st.email = pf.email; } catch (e) {}
      }
      // The pop-out opens on the same side as the launcher (flore.com pins it lower RIGHT; RGO lower left).
      var onRight = false;
      if (o.float && opener && opener.getBoundingClientRect) { var lr = opener.getBoundingClientRect(); onRight = lr.left + lr.width / 2 > window.innerWidth / 2; }
      if (o.float) el.style.display = 'none';
      var ov = document.createElement('div'); ov.className = 'fi-ov' + (o.float ? ' fi-ov-l' + (onRight ? ' fi-ov-r' : '') : '');
      var dlg = document.createElement('div'); dlg.className = 'fi-dlg';
      dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true'); dlg.setAttribute('aria-label', 'Start your journey');
      ov.appendChild(dlg);
      var vw = document.createElement('div'); vw.className = 'fi-vw';
      var v;
      if (video) {
        v = document.createElement('video'); v.className = 'fi-vid'; v.controls = true; v.playsInline = true; v.setAttribute('playsinline', '');
        v.preload = 'auto'; if (poster) v.poster = poster;
        v.setAttribute('aria-label', 'Welcome to Flore from Craig Rouskey, CEO and co-founder');
        var src = document.createElement('source'); src.src = video; src.type = 'video/mp4'; v.appendChild(src);
        try {
          var tr = document.createElement('track'); tr.kind = 'captions'; tr.srclang = 'en'; tr.label = 'English'; tr.default = true;
          tr.src = URL.createObjectURL(new Blob([VTT], { type: 'text/vtt' })); v.appendChild(tr);
        } catch (e) {}
        vw.appendChild(v); dlg.appendChild(vw);
      }
      var x = document.createElement('button'); x.type = 'button'; x.className = 'fi-x'; x.setAttribute('aria-label', 'Close'); x.innerHTML = '&times;';
      dlg.appendChild(x);
      var pn = document.createElement('div'); pn.className = 'fi-pn'; dlg.appendChild(pn);
      pn.innerHTML = '<p class="fi-h">Start your journey</p><p class="fi-pg"></p><div class="fi-bar"><i></i></div><div class="fi-log" aria-live="polite"></div>';
      var pg = pn.querySelector('.fi-pg'), bar = pn.querySelector('.fi-bar i'), log = pn.querySelector('.fi-log');
      document.body.appendChild(ov);
      var prevOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
      function close() {
        if (v) try { v.pause(); } catch (e) {}
        ov.remove(); document.documentElement.style.overflow = prevOverflow;
        document.removeEventListener('keydown', onKey); el.style.display = ''; card();
        var c = el.querySelector('.fi-card,.fi-fl'); if (c) c.focus();
      }
      function onKey(e) {
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') { // keep focus inside the dialog
          var f = dlg.querySelectorAll('button,input,video,a[href]'); if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
      x.addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      document.addEventListener('keydown', onKey);
      if (v && !st.done) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

      function bubble(cls, txt) { var b = document.createElement('div'); b.className = 'fi-m ' + cls; b.textContent = txt; log.appendChild(b); return b; }
      function scroll() { log.scrollTop = log.scrollHeight; }
      function qText(i) { var q = Q[i].q; return typeof q === 'function' ? q(st.a) : q; }
      function ansText(i) { var k = Q[i].k, a = st.a[k]; var t = Array.isArray(a) ? a.join(', ') : a; if (k === 'concerns' && st.a.other) t += (t ? ', ' : '') + st.a.other; if (k === 'contact' && st.a.phone) t += ' (' + st.a.phone + ')'; return t; }
      // Steps per path: symptoms = the 5 questions; specialist = 1 (how to reach you); order/other = 1 (the note).
      var CONTACT_IX = Q.length - 1;
      function steps() { return st.need === 'symptoms' ? Q.length : (st.need === 'specialist' || st.need === 'order' || st.need === 'other') ? 1 : 0; }
      function progress() {
        var total = steps(), n = Math.min(st.step, total);
        pg.textContent = st.done ? 'Sent' : !st.need ? 'Tap one to start' :
          (st.step < total ? (total > 1 ? 'Question ' + (st.step + 1) + ' of ' + total : 'One quick question') : 'Last step: where to reach you');
        bar.style.width = (st.done ? 100 : !st.need ? 0 : (n + 1) / (total + 1) * 100) + '%';
      }
      function needLabel() { for (var i = 0; i < NEEDS.length; i++) if (NEEDS[i].k === st.need) return NEEDS[i].label; return ''; }
      function hello() { return "Thanks for stopping in. How can I help you?"; }
      function doneText() {
        var who = st.need === 'symptoms' || st.need === 'specialist' ? 'a gut health specialist' : "Flore's team";
        return 'Thanks' + (st.name ? ', ' + st.name.split(/\s+/)[0] : '') + '. Your message is in, and ' + who +
          ' will contact you as soon as possible. Need us sooner? support@flore.com or 415-326-4743 (6am to 5pm CST, Monday to Saturday).';
      }

      function render() {
        log.innerHTML = '';
        bubble('fi-a', hello());
        if (st.need) bubble('fi-u', needLabel());
        if (st.need === 'symptoms') {
          for (var i = 0; i < Math.min(st.step, Q.length); i++) {
            bubble('fi-a', qText(i)); bubble('fi-u', ansText(i));
            if (Q[i].k === 'concerns' && (st.a.concerns || []).indexOf(RED_FLAG) > -1) warn();
          }
        } else if (st.need === 'specialist' && st.step > 0) {
          bubble('fi-a', qText(CONTACT_IX)); bubble('fi-u', ansText(CONTACT_IX));
        } else if ((st.need === 'order' || st.need === 'other') && st.step > 0) {
          bubble('fi-a', NOTE_Q[st.need]); bubble('fi-u', st.msg);
          if (RED_FLAG_RE.test(st.msg)) warn();
        }
        progress();
        if (st.done) { bubble('fi-a', doneText()); addClose(); }
        else if (!st.need) askNeed();
        else if (st.need === 'finder') finder();
        else if (st.need === 'symptoms' && st.step < Q.length) ask(st.step);
        else if (st.need === 'specialist' && st.step < 1) ask(CONTACT_IX);
        else if ((st.need === 'order' || st.need === 'other') && st.step < 1) askNote();
        else finish();
        if (st.need && !st.done) {
          var r = document.createElement('button'); r.type = 'button'; r.className = 'fi-lnk'; r.textContent = 'Start over';
          r.addEventListener('click', function () { var n = st.name, m = st.email; st = fresh({ name: n, email: m }); save(st); render(); });
          var p = document.createElement('p'); p.className = 'fi-note'; p.appendChild(r); log.appendChild(p);
        }
        scroll();
      }

      function askNeed() {
        var wrap = document.createElement('div'); wrap.className = 'fi-ops fi-need'; wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', 'How can I help you?');
        NEEDS.forEach(function (n) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'fi-op' + (n.cta ? ' fi-cta' : ''); b.textContent = n.label; b.dataset.need = n.k;
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () { st.need = n.k; st.step = 0; save(st); render(); });
          wrap.appendChild(b);
        });
        log.appendChild(wrap);
        var firstBtn = wrap.querySelector('.fi-op'); if (firstBtn) try { firstBtn.focus({ preventScroll: true }); } catch (e) {}
      }

      // Program finder hand-off: nothing is sent. Host option `finder` (function or URL) wins, then the page's own
      // quiz button (.js-quiz on flore.com), then flore.com.
      function finder() {
        bubble('fi-a', 'Our program finder asks a few quick questions and matches you to the right test or program.');
        var w = document.createElement('div'); w.className = 'fi-ops';
        var b = document.createElement('button'); b.type = 'button'; b.className = 'fi-btn'; b.textContent = 'Find your program';
        b.addEventListener('click', function () {
          var f = o.finder; st = fresh({ name: st.name, email: st.email }); save(st);
          close();
          if (typeof f === 'function') { try { f(); } catch (e) {} return; }
          var q = !f && document.querySelector('.js-quiz');
          if (q) { q.click(); return; }
          location.href = (typeof f === 'string' && f) ? f : FINDER_URL;
        });
        w.appendChild(b); log.appendChild(w);
        try { b.focus({ preventScroll: true }); } catch (e) {}
      }

      function askNote() {
        bubble('fi-a', NOTE_Q[st.need]);
        var f = document.createElement('div'); f.className = 'fi-f';
        var t = document.createElement('textarea'); t.className = 'fi-in fi-ta'; t.rows = 4; t.maxLength = 1000;
        t.setAttribute('aria-label', NOTE_Q[st.need]); t.value = st.msg || '';
        var ok = document.createElement('button'); ok.type = 'button'; ok.className = 'fi-btn'; ok.textContent = 'Continue';
        function chk() { ok.disabled = t.value.trim().length < 3; }
        t.addEventListener('input', chk); chk();
        ok.addEventListener('click', function () { st.msg = t.value.trim().slice(0, 1000); next(); });
        f.appendChild(t); var w = document.createElement('div'); w.appendChild(ok); f.appendChild(w);
        log.appendChild(f); try { t.focus({ preventScroll: true }); } catch (e) {}
      }
      function warn() { bubble('fi-m fi-warn', 'Blood in stool or unexplained weight loss should be seen by a doctor soon. Please contact your doctor or urgent care; we will still follow up.'); }
      function addClose() { var w = document.createElement('div'); w.className = 'fi-ops'; var b = document.createElement('button'); b.type = 'button'; b.className = 'fi-btn'; b.textContent = 'Close'; b.addEventListener('click', close); w.appendChild(b); log.appendChild(w); }

      function ask(i) {
        var q = Q[i]; bubble('fi-a', qText(i));
        var wrap = document.createElement('div'); wrap.className = 'fi-ops'; wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', qText(i));
        var picked = Array.isArray(st.a[q.k]) ? st.a[q.k].slice() : [];
        var other, phone, go;
        q.opts.forEach(function (label) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'fi-op'; b.textContent = label;
          b.setAttribute('aria-pressed', picked.indexOf(label) > -1 ? 'true' : 'false');
          b.addEventListener('click', function () {
            if (q.multi) {
              var at = picked.indexOf(label); if (at > -1) picked.splice(at, 1); else picked.push(label);
              b.setAttribute('aria-pressed', at > -1 ? 'false' : 'true'); upd(); return;
            }
            st.a[q.k] = label;
            if (q.k === 'contact' && label !== 'Email') { showPhone(); return; }
            st.a.phone = ''; next();
          });
          wrap.appendChild(b);
        });
        log.appendChild(wrap);
        if (q.other) {
          other = document.createElement('input'); other.className = 'fi-in'; other.placeholder = 'Something else? (optional)';
          other.setAttribute('aria-label', 'Something else (optional)'); other.maxLength = 300; other.value = st.a.other || '';
          other.addEventListener('input', upd); log.appendChild(other);
        }
        if (q.multi) {
          var w = document.createElement('div'); w.className = 'fi-ops';
          go = document.createElement('button'); go.type = 'button'; go.className = 'fi-btn'; go.textContent = 'Continue';
          go.addEventListener('click', function () { st.a[q.k] = picked; st.a.other = other ? other.value.trim() : ''; next(); });
          w.appendChild(go); log.appendChild(w); upd();
        }
        function upd() { if (go) go.disabled = !(picked.length || (other && other.value.trim())); }
        function showPhone() {
          if (phone) { phone.focus(); return; }
          Array.prototype.forEach.call(wrap.children, function (c) { c.setAttribute('aria-pressed', c.textContent === st.a.contact ? 'true' : 'false'); });
          var f = document.createElement('div'); f.className = 'fi-f';
          phone = document.createElement('input'); phone.className = 'fi-in'; phone.type = 'tel'; phone.autocomplete = 'tel';
          phone.placeholder = 'Phone number'; phone.setAttribute('aria-label', 'Phone number'); phone.value = st.a.phone || '';
          var ok = document.createElement('button'); ok.type = 'button'; ok.className = 'fi-btn'; ok.textContent = 'Continue';
          function chk() { ok.disabled = phone.value.replace(/\D/g, '').length < 7; }
          phone.addEventListener('input', chk); chk();
          ok.addEventListener('click', function () { st.a.phone = phone.value.trim().slice(0, 30); next(); });
          f.appendChild(phone); var w2 = document.createElement('div'); w2.appendChild(ok); f.appendChild(w2);
          log.appendChild(f); phone.focus(); scroll();
        }
        scroll();
        var firstBtn = wrap.querySelector('.fi-op'); if (firstBtn) try { firstBtn.focus({ preventScroll: true }); } catch (e) {}
      }
      function next() { st.step++; save(st); render(); }

      function finish() {
        var toSpec = st.need === 'symptoms' || st.need === 'specialist';
        var SEND = toSpec ? 'Send to a specialist' : "Send to Flore's team";
        bubble('fi-a', 'Last step: where should we reach you?');
        var f = document.createElement('form'); f.className = 'fi-f'; f.noValidate = true;
        f.innerHTML = '<input class="fi-in" name="n" autocomplete="name" placeholder="Your name" aria-label="Your name" value="' + esc(st.name) + '">' +
          '<input class="fi-in" name="e" type="email" autocomplete="email" placeholder="Email" aria-label="Email" value="' + esc(st.email) + '">' +
          '<label class="fi-ck"><input type="checkbox" name="c"><span>' + esc(CONTACT_T) + ' <a href="https://flore.com/policies/privacy-policy" target="_blank" rel="noopener">Privacy policy</a></span></label>' +
          '<label class="fi-ck"><input type="checkbox" name="m"><span>' + esc(MKT_T) + ' (optional)</span></label>' +
          '<input type="text" name="company_website" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0">' +
          '<p class="fi-err" aria-live="polite"></p>' +
          '<div><button class="fi-btn" type="submit" disabled>' + esc(SEND) + '</button></div>' +
          '<p class="fi-note">Nothing has been sent yet. When you tap Send, your answers, name and email go to Flore\'s team so we can contact you.</p>';
        log.appendChild(f);
        var b = f.querySelector('.fi-btn'), err = f.querySelector('.fi-err');
        function ok() { return f.n.value.trim() && EMAIL_RE.test(f.e.value.trim()) && f.c.checked; }
        f.addEventListener('input', function () { b.disabled = !ok(); err.textContent = ''; });
        f.addEventListener('change', function () { b.disabled = !ok(); });
        b.disabled = !ok();
        f.addEventListener('submit', function (ev) {
          ev.preventDefault(); if (!ok()) return;
          st.name = f.n.value.trim().slice(0, 80); st.email = f.e.value.trim().toLowerCase(); save(st);
          var mkt = !!f.m.checked; b.disabled = true; b.textContent = 'Sending\u2026';
          fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
            name: st.name, email: st.email, sourceUrl: source, company_website: f.company_website.value || '', form_ms: (window.performance && performance.now) ? Math.round(performance.now()) : undefined,
            answers: Object.assign({}, st.need === 'symptoms' ? st.a : (st.need === 'specialist' ? { contact: st.a.contact, phone: st.a.phone } : {}), { need: st.need, message: st.msg || '' }),
            contactConsent: true, contactConsentText: CONTACT_T, contactConsentVersion: CONTACT_V,
            consent: mkt, consentText: mkt ? MKT_T : '', consentVersion: mkt ? MKT_V : ''
          }) })
            .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && j.ok, j: j }; }); })
            .then(function (x) {
              if (!x.ok) { err.textContent = (x.j && x.j.error) || 'That did not go through. Please try again, or email support@flore.com.'; b.disabled = false; b.textContent = SEND; return; }
              st.done = true; save(st); render();
            })
            .catch(function () { err.textContent = 'We could not reach our team just now. Please try again, or email support@flore.com.'; b.disabled = false; b.textContent = SEND; });
        });
        try { (st.name ? (st.email ? f.c : f.e) : f.n).focus({ preventScroll: true }); } catch (e) {}
      }

      render();
    }

    card();
  }

  window.FloreIntaker = { mount: mount, float: float };
  function auto() { var n = document.querySelectorAll('[data-flore-intaker]'); for (var i = 0; i < n.length; i++) mount(n[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto); else auto();
})();
